import { React, useState, useEffect } from "react";
import {
	Form,
	Grid,
	Dropdown,
	Image,
	Divider,
	Label,
	/* 	TextArea, */
} from "semantic-ui-react";
import { isEmpty, map, get, isEqual, find, isNaN } from "lodash";
import PropTypes from "prop-types";
import Joi from "joi";
import TextAreaAutoSize from "react-textarea-autosize";

// Components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";

// Redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";
import TextAreaInput from "@Components/TextArea";
// import dataHandler from "@Utils/dataHandler";
// Images
import { Facebook, Telegram, Twitter, Whatsapp, Instagram, Personal, Email } from "@Assets/index"; // Instagram

// Utils
import { dropdownFormat } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const emailProviders = [
	{ id: "Gmail" },
	{ id: "Outlook" },
	{ id: "Hotmail" },
	{ id: "Yahoo" },
	{ id: "iCloud" },
	{ id: "AOL" },
	{ id: "Zoho" },
	{ id: "GMX" },
];

const ChanelCrud = ({ dispatch, channelsHandler, onClose, data, modalOptionCompany, modalMode, platforms, companyName }) => {
	// hooks
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	// dropDownData
	const [channelNamesData, setChannelNamesData] = useState([]);
	const [groupsData, setGroupsData] = useState([]);
	const [channelName, setChannelName] = useState("");
	const [modalOption, setModalOption] = useState("");

	// formData
	const [initialFormData, setInitialFormData] = useState({});
	const [errors, setErrors] = useState({ labelErr: "", channelId: "", accessTokenErr: "", plataformaErr: "" });
	const [formData, setFormData] = useState({
		// platform: "",
		platformId: "",
		defaultGroupId: "",
		label: "",
		account: "",
		accessToken: "",
		accessSecret: "",
		accessExtra: "",
		isActive: true,
		allowCalls: false,
		callMode: "p2p",
		sipAddress: "",
		note: "",
	});
	// const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15, companyId: data.companyId };
	const schema = Joi.object().keys({
		labelErr: Joi.string().min(2).required().messages({
			"string.min": "El nombre debe tener al menos 2 caracteres.",
			"string.empty": "El campo Teléfono/Cuenta es obligatorio.",
			"any.required": "El campo Teléfono/Cuenta es obligatorio.",
		}),

		channelId: Joi.number().required().messages({
			"number.base": "Debes seleccionar una plataforma válida.",
			"any.required": "El campo plataforma es obligatorio.",
		}),

		accessTokenErr: Joi.string().required().messages({
			"string.empty": "El token es obligatorio.",
			"any.required": "El campo token es obligatorio.",
		}),

		plataformaErr: Joi.string().required().messages({
			"string.empty": "El campo ID Plataforma es obligatorio.",
			"any.required": "El campo ID Plataforma es obligatorio.",
		}),
	});

	// Effects
	useEffect(() => {
		setModalOption(modalMode);

		if (!platforms?.length) return;

		const formattedPlatforms = dropdownFormat(platforms, "name", "id", ["text"], ["asc"]);
		const orderAlphabetically = formattedPlatforms.sort((a, b) => {
			return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
		});
		setChannelNamesData(orderAlphabetically);
		(async () => {
			const groupsDataResponse = await dispatch(genericAction({ method: "get", route: `/groups/all/${data.companyId}` }));

			if (groupsDataResponse) {
				setGroupsData(dropdownFormat(groupsDataResponse, "name", "id", ["text"], ["asc"]));
			}
			if (data && data.modalOption !== "Add") {
				const channelData = data.channel;
				const platformId = get(channelData, "platformId", "");
				const platformName = get(channelData, "platform.name", "");
				setChannelName(platformName);
				const newData = {
					...formData,
					platformId,
					platform: {
						id: platformId,
						text: platformName,
					},
					defaultGroupId: get(channelData, "defaultGroupId", ""),
					label: get(channelData, "label", ""),
					account: get(channelData, "account", ""),
					accessToken: get(channelData, "accessToken", ""),
					accessSecret: get(channelData, "accessSecret", ""),
					accessExtra: get(channelData, "accessExtra", ""),
					isActive: get(channelData, "isActive", true),
					allowCalls: get(channelData, "allowCalls", false),
					callMode: get(channelData, "callMode", "p2p"),
					sipAddress: get(channelData, "sipAddress", ""),
					note: get(channelData, "note", ""),
				};

				setFormData(newData);
				setInitialFormData(newData);
			}
		})();
	}, [data, platforms]);

	// const getNameChannel = (value, optionsChannelName) => {
	// 	const filterNameChanel = map(
	// 		filter(optionsChannelName, (item) => {
	// 			return item.value === value;
	// 		}),
	// 		(item) => {
	// 			return item.text;
	// 		}
	// 	);
	// 	setChannelName(filterNameChanel);
	// };

	// modal handlers
	const onSaveClear = () => {
		setFormData(initialFormData);
	};

	const confirmModal = () => {
		onClose();
	};

	const closeModal = () => {
		if (isEqual(initialFormData, formData)) {
			onClose();
		} else {
			setOpenConfirmModal(true);
		}
	};

	// img handlers
	// eslint-disable-next-line react/no-unstable-nested-components
	const ImageChannel = (channel) => {
		const platformObj = find(platforms, (p) => {
			return p.id === channel;
		});
		const platformName = platformObj?.name?.toLowerCase() || "";
		switch (channel) {
			case 2:
				return <Image src={Whatsapp} className={styles.channelImagen} />;
			case 4:
				return <Image src={Twitter} className={styles.channelImagen} />;
			case 3:
				return <Image src={Facebook} className={styles.channelImagen} />;
			case 1:
				return <Image src={Telegram} className={styles.channelImagen} />;
			case 5:
				return <Image src={Personal} className={styles.channelImagen} />;
			case 6:
				return <Image src={Instagram} className={styles.channelImagen} />;
			default:
				if (platformName === "email") {
					return <Image src={Email} className={styles.channelImagen} />;
				}
				return <Image src="https://react.semantic-ui.com/images/wireframe/image.png" className={styles.channelImagen} />;
		}
	};

	// input handlers
	const handleInput = (e, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	const phoneHandleInput = (e, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	const handleInputDropdown = (e, { name, value }) => {
		if (name === "platformId") {
			const prevPlatform = platforms?.find((p) => {
				return p.id === formData.platformId;
			});
			const nextPlatform = platforms?.find((p) => {
				return p.id === value;
			});
			const wasEmail = prevPlatform?.name?.toLowerCase() === "email";
			const isEmail = nextPlatform?.name?.toLowerCase() === "email";
			setFormData((prev) => {
				return {
					...prev,
					[name]: value,
					accessSecret: wasEmail || isEmail ? "" : prev.accessSecret,
				};
			});
		} else {
			setFormData((prev) => {
				return {
					...prev,
					[name]: value,
				};
			});
		}
	};

	// const dropDownData = () => {
	// 	/* 		const { groups } = props; */

	// 	// setChannelNamesData(dropdownFormat(channelNames, "name", "name"));
	// 	setGroupsData(dropdownFormat(groups, "name", "groupId"));
	// };

	// const channelLabel = (channel) => {
	// 	switch (channel) {
	// 		// case 2:
	// 		// 	return "Teléfono:";
	// 		// case 4:
	// 		// 	return "Cuenta:";
	// 		// case 3:
	// 		// 	return "Página:";
	// 		// case 1:
	// 		// 	return "Bot:";
	// 		default:
	// 			return "ID Plataforma:";
	// 	}
	// };

	// const channelValidator = () => {
	// 	let isNotValid = false;
	// 	if (isEmpty(formData.account)) {
	// 		isNotValid = true;
	// 	}
	// 	if ((formData.channel === "Whatsapp" || formData.channel === "Telegram") && formData.account.length < 10) {
	// 		isNotValid = true;
	// 	}
	// 	if (isEmpty(formData.accessToken) && data.modalOption !== "Edit") {
	// 		isNotValid = true;
	// 	}
	// 	if (formData.channel === "Twitter") {
	// 		if (isEmpty(formData.accessSecret)) {
	// 			isNotValid = true;
	// 		}
	// 	}

	// 	return isNotValid;
	// };

	// save handlers

	const save = async () => {
		if (formData.callMode === "sip" && isEmpty(formData.sipAddress)) {
			setErrors((previous) => {
				return { ...previous, sipAddressErr: "El número SIP de WhatsApp es obligatorio." };
			});
			return;
		}
		const errorssObj = {
			labelErr: formData.label,
			accessTokenErr: formData.accessToken,
			plataformaErr: formData.account,
			channelId: formData.platformId,
		};
		const validation = schema.validate(errorssObj, { abortEarly: false });
		if (validation.error) {
			const { details } = validation.error;
			let errorssVal = {
				labelErr: "",
				accessTokenErr: "",
				plataformaErr: "",
				channelId: "",
			};
			map(details, (item) => {
				errorssVal = { ...errorssVal, [item.context.key]: item.message };
			});
			setErrors(errorssVal);
		} else {
			const defaultGroupId = isNaN(parseInt(formData.defaultGroupId, 10)) ? null : parseInt(formData.defaultGroupId, 10);
			const selectedGroup = find(groupsData, { value: defaultGroupId });

			if (data.saveOption === "Add") {
				const addData = {
					...formData,
					companyId: data.companyId,
					defaultGroupId,
					defaultGroup: isEmpty(selectedGroup)
						? null
						: {
								id: selectedGroup.value,
								name: selectedGroup.text,
						  },
					accessSecret: isEmpty(formData.accessSecret) ? null : formData.accessSecret,
					accessExtra: isEmpty(formData.accessExtra) ? null : formData.accessExtra,
					platform: {
						platformId: formData.platform,
						name: formData.platform?.text,
					},
					isActive: formData.isActive,
					allowCalls: formData.allowCalls,
				};

				channelsHandler(addData, data.saveOption);
				onClose();
			} else {
				switch (modalOption) {
					case "Add":
						// eslint-disable-next-line no-case-declarations
						const newData = await dispatch(
							genericAction({
								method: "post",
								route: `companyChannels`,
								body: {
									...formData,
									companyId: data.companyId,
									defaultGroupId,
									accessSecret: isEmpty(formData.accessSecret) ? null : formData.accessSecret,
									accessExtra: isEmpty(formData.accessExtra) ? null : formData.accessExtra,
									isActive: formData.isActive,
									allowCalls: formData.allowCalls,
								},
							})
						);
						if (isEmpty(newData)) {
							onSaveClear();
						} else {
							channelsHandler(newData, data.modalOption);
							onClose();
						}
						break;
					case "Edit":
						const dataEdit = {}; // eslint-disable-line

						if (!isEqual(formData.platformId, initialFormData.platformId)) {
							dataEdit.platformId = formData.platformId;
						}
						if (!isEqual(formData.defaultGroupId, initialFormData.defaultGroupId)) {
							dataEdit.defaultGroupId = defaultGroupId;
						}
						if (!isEqual(formData.label, initialFormData.label)) {
							dataEdit.label = formData.label;
						}
						if (!isEqual(formData.account, initialFormData.account) && !isEmpty(formData.account)) {
							dataEdit.account = formData.account;
						}
						if (!isEqual(formData.accessToken, initialFormData.accessToken)) {
							dataEdit.accessToken = formData.accessToken ? formData.accessToken : null;
						}
						if (!isEqual(formData.accessSecret, initialFormData.accessSecret)) {
							dataEdit.accessSecret = formData.accessSecret ? formData.accessSecret : null;
						}
						if (!isEqual(formData.accessExtra, initialFormData.accessExtra)) {
							dataEdit.accessExtra = formData.accessExtra ? formData.accessExtra : null;
						}

						if (!isEqual(formData.isActive, initialFormData.isActive)) {
							dataEdit.isActive = formData.isActive;
						}
						if (!isEqual(formData.allowCalls, initialFormData.allowCalls)) {
							dataEdit.allowCalls = formData.allowCalls;
						}
						if (!isEqual(formData.callMode, initialFormData.callMode)) {
							dataEdit.callMode = formData.callMode;
						}
						if (!isEqual(formData.sipAddress, initialFormData.sipAddress)) {
							dataEdit.sipAddress = formData.sipAddress || null;
						}

						// dataEdit.isActive = formData.isActive;

						if (!isEqual(formData.note, initialFormData.note)) {
							dataEdit.note = formData.note ? formData.note : null;
						}

						// eslint-disable-next-line no-case-declarations
						const newDataEdit = await dispatch(
							genericAction({ method: "patch", route: `companyChannels/${data.channel.id}`, body: dataEdit })
						);
						channelsHandler(newDataEdit, modalOption);
						onClose();
						break;

					default:
						break;
				}
			}
		}
	};

	// const validateData = () => {
	// 	if (
	// 		isEqual(
	// 			{
	// 				channelId: initialFormData.channelId,
	// 				defaultGroupId: initialFormData.defaultGroupId,
	// 				label: initialFormData.label,
	// 				account: initialFormData.account,
	// 				accessToken: initialFormData.accessToken,
	// 				accessSecret: initialFormData.accessSecret,
	// 				accessExtra: initialFormData.accessExtra,
	// 			},
	// 			{
	// 				channelId: formData.channelId,
	// 				defaultGroupId: formData.defaultGroupId,
	// 				label: formData.label,
	// 				account: formData.account,
	// 				accessToken: formData.accessToken,
	// 				accessSecret: formData.accessSecret,
	// 				accessExtra: formData.accessExtra,
	// 			}
	// 		)
	// 	) {
	// 		// onClose();
	// 		return onClose();
	// 	}
	// 	return save();
	// };

	const selectedPlatform = platforms?.find((p) => {
		return p.id === formData.platformId;
	});
	const isEmailPlatform = selectedPlatform && selectedPlatform.name?.toLowerCase() === "email";
	const isWhatsappPlatform = selectedPlatform && selectedPlatform.name?.toLowerCase() === "whatsapp";

	return (
		<IKModal
			title={
				!get(data, "channel.id")
					? `${companyName}: Creando Plataforma${formData.platformId ? ` - ${channelName}` : ""}`
					: `${companyName}: Plataforma - ${channelName}`
			}
			mode={!get(data, "channel.id") ? "Add" : modalOption}
			noMode={modalOptionCompany === "Watch"}
			setMode={setModalOption}
			onClose={closeModal}
			saveDisabled={modalOption === "Edit" && isEqual(formData, initialFormData)}
			onSuccess={save}
			size="tiny"
			fullHeight>
			<div className={styles.grid}>
				<fieldset className={styles.fieldset}>
					<Form noValidate>
						<Grid columns={1}>
							<Grid.Column width={16} className={styles.column}>
								<Grid.Row className={styles.row}>
									<div className={styles.containerState}>
										<div className={styles.divState}>
											<span className={styles.label1}>Activo:</span>
											<Form.Checkbox
												id="a"
												toggle
												label={formData.isActive ? "Sí" : "No"}
												name="isActive"
												checked={formData.isActive}
												onChange={(e, { checked }) => {
													setFormData((prev) => {
														return {
															...prev,
															isActive: checked,
														};
													});
												}}
												disabled={modalOption === "Watch"}
											/>
										</div>
										{isWhatsappPlatform && (
											<div className={styles.divState}>
												<span className={styles.label1}>Llamadas:</span>
												<Form.Checkbox
													id="allowCalls"
													toggle
													label={formData.allowCalls ? "Si" : "No"}
													name="allowCalls"
													checked={formData.allowCalls}
													onChange={(e, { checked }) => {
														setFormData((prev) => {
															return {
																...prev,
																allowCalls: checked,
															};
														});
													}}
													disabled={modalOption === "Watch"}
												/>
											</div>
										)}
									</div>
									{isWhatsappPlatform && formData.allowCalls && (
										<>
											<Form.Field className={styles.field}>
												<div style={{ width: "100%" }}>
													<span className={styles.label}>Modo de llamadas:</span>
													<Dropdown
														selection
														fluid
														name="callMode"
														value={formData.callMode}
														options={[
															{ key: "p2p", value: "p2p", text: "Graph API (P2P)" },
															{ key: "sip", value: "sip", text: "SIP / mediasoup" },
														]}
														onChange={handleInputDropdown}
														disabled={modalOption === "Watch"}
													/>
												</div>
											</Form.Field>
											{formData.callMode === "sip" && (
												<Form.Field className={styles.field}>
													<Input
														value={formData.sipAddress}
														disabled={modalOption === "Watch"}
														icon="phone"
														name="sipAddress"
														label="Número SIP de WhatsApp (E.164)"
														placeholder="+15551234567"
														required
														fluid
														error={
															!isEmpty(errors.sipAddressErr) && {
																content: errors.sipAddressErr,
																pointing: "above",
															}
														}
														onChange={handleInput}
													/>
												</Form.Field>
											)}
										</>
									)}
									<Form.Field className={styles.field}>
										<div style={{ width: "100%" }}>
											<span className={styles.label}>
												Plataforma: <span className={styles.required}>*</span>
											</span>
											<Dropdown
												className={styles.dropdownStyle}
												disabled={modalOption === "Watch"}
												required
												placeholder="Elegir Canal"
												fluid
												clearable
												value={formData.platformId}
												name="platformId"
												search
												selection
												onChange={handleInputDropdown}
												options={channelNamesData}
											/>
											{!isEmpty(errors.channelId) && (
												<Label basic color="red" className={styles.errorLabel}>
													{errors.channelId}
												</Label>
											)}
										</div>
										{ImageChannel(formData.platformId)}
									</Form.Field>
								</Grid.Row>
								<Divider />
								<Grid.Row className={styles.row}>
									<span className={styles.label}>Grupo/Sucursal predeterminado:</span>
									<Dropdown
										className={styles.dropdownStyle}
										disabled={modalOption === "Watch"}
										placeholder="Elegir Grupo:"
										fluid
										clearable
										value={formData.defaultGroupId}
										name="defaultGroupId"
										search
										selection
										onChange={handleInputDropdown}
										options={groupsData}
									/>
								</Grid.Row>
								<Divider />
								<Grid.Row className={styles.row}>
									<Form.Field className={styles.field}>
										<Input
											value={String(formData.label)}
											disabled={modalOption === "Watch"}
											icon="user"
											name="label"
											label="Nombre de la Cuenta/Teléfono"
											required
											fluid
											error={!isEmpty(errors.labelErr) && { content: errors.labelErr, pointing: "above" }}
											onChange={handleInput}
										/>
									</Form.Field>
								</Grid.Row>
								{/* {formData.channelId === 2 || formData.channelId === 1 ? ( */}
								{/* ) : ( */}
								{/* // <Grid.Row className={styles.row}> */}
								{/* // 	<Form.Field className={styles.field}> */}
								{/* // 		<Input */}
								{/* // 			value={String(formData.account)}
									// 			disabled={data.modalOption === "Watch" || data.modalOption === "Edit"}
									// 			icon="id card"
									// 			name="account"
									// 			label={channelLabel(formData.channelId)}
									// 			required
									// 			fluid
									// 			onChange={handleInput}
									// 		/>
									// 	</Form.Field>
									// </Grid.Row>
								// )} */}

								<Grid.Row className={styles.row}>
									<Input
										className={styles.input}
										icon="phone"
										label="ID Plataforma:"
										placeholder="Phone ID, ID"
										name="account"
										required
										disabled={modalOption === "Watch"}
										fluid
										value={formData.account}
										onChange={phoneHandleInput}
										error={!isEmpty(errors.plataformaErr) && { content: errors.plataformaErr, pointing: "above" }}
									/>
								</Grid.Row>

								<TextAreaInput
									value={formData.accessToken}
									disabled={modalOption === "Watch"}
									name="accessToken"
									label="Token:"
									required
									showRequired
									error={errors.accessTokenErr}
									isPassword
									onChange={(e) => {
										return handleInput(e, { name: "accessToken", value: e.target.value });
									}}
									minRows={1}
								/>

								<Grid.Row className={styles.row}>
									<Form.Field className={styles.field}>
										<Input
											value={formData.accessSecret ?? ""}
											disabled={modalOption === "Watch"}
											icon="user secret"
											name="accessSecret"
											label="Secret:"
											fluid
											onChange={handleInput}
											// width={10}
										/>
									</Form.Field>
								</Grid.Row>

								<Grid.Row className={styles.row}>
									<Form.Field>
										{isEmailPlatform ? (
											<div className={styles.columnField}>
												<span className={styles.label}>Extra:</span>
												<Dropdown
													placeholder="Selecciona proveedor de email"
													fluid
													selection
													clearable
													disabled={modalOption === "Watch"}
													options={emailProviders.map((provider) => {
														return { key: provider.id, text: provider.id, value: provider.id };
													})}
													value={formData.accessExtra || ""}
													name="accessExtra"
													onChange={(e, { value }) => {
														return setFormData({ ...formData, accessExtra: value });
													}}
												/>
											</div>
										) : (
											<Input
												value={formData.accessExtra}
												disabled={modalOption === "Watch"}
												icon="linkify"
												name="accessExtra"
												label="Extra:"
												placeholder="Url"
												onChange={handleInput}
												width={10}
											/>
										)}
									</Form.Field>
								</Grid.Row>
								{(formData.platformId === 6 || formData.platformId === 3 || formData.platformId === 4) && (
									<Grid.Row className={styles.row}>
										<Form.Field>
											<span className={styles.label}>
												Cuenta {`${formData.platformId === 6 ? "Instagram" : formData.platformId === 3 ? "Facebook" : "Twitter"}`}:{" "}
												<span className={styles.optional}>(opcional)</span>
											</span>
											<TextAreaAutoSize
												value={formData.note}
												disabled={modalOption === "Watch"}
												name="note"
												placeholder={`Cuenta de ${
													formData.platformId === 6 ? "Instagram" : formData.platformId === 3 ? "Facebook" : "Twitter"
												} y contraseña`}
												onChange={(e) => {
													handleInput(e, { name: "note", value: e.target.value });
												}}
												rows={3}
											/>
										</Form.Field>
									</Grid.Row>
								)}
							</Grid.Column>
						</Grid>
					</Form>
				</fieldset>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Cerrar"
					content="Está seguro que desea salir del formulario"
					onConfirm={confirmModal}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</IKModal>
	);
};

ChanelCrud.propTypes = {
	data: PropTypes.object,
	channelsHandler: PropTypes.func,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	modalOption: PropTypes.string,
	saveOption: PropTypes.string,
	modalMode: PropTypes.string,
	modalOptionCompany: PropTypes.string,
	platforms: PropTypes.array,
	companyName: PropTypes.string,
};

function mapStateToProps({ platforms }) {
	return {
		platforms: platforms.platforms || [],
	};
}
/* const mapDispatchToProps = {
	createChannel,
	updateChannel,
	delChannel,
}; */

export default connect(mapStateToProps)(ChanelCrud);
